/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';
import {OfferVO} from '@well/domain';
import { ShipmentGroupVoModel } from './shipment-group-vo.model';

export class ShipmentGroupDetailModel extends JSONable {
  shipmentGroupVo: ShipmentGroupVoModel | undefined = undefined;
  offers: Array<OfferVO> | undefined = undefined;
}
